import React from "react";
import EmailThreadList from "../../../components/email/EmailThreadList";
import {
  useAllThreadsSentQuery,
  useUpdateStarredMutation,
  useUpdateNonActionableMutation,
  useUpdateActionableMutation,
} from "../../../Services/email/EmailInbox";
import SentFilterModal from "../../../components/email/SentFilterModal";

const Sent = () => {
  return (
    <EmailThreadList
      useThreadsQuery={useAllThreadsSentQuery}
      useUpdateStarredMutation={useUpdateStarredMutation}
      useUpdateNonActionableMutation={useUpdateNonActionableMutation}
      useUpdateActionableMutation={useUpdateActionableMutation}
      FilterModalComponent={SentFilterModal}
      filterSessionKey="selectedFilter"
      sessionKeyPrefix="sentInitial_"
      title="Sent"
      filterKey="sentSelectedFilter1"
    />
  );
};

export default Sent;
